import { FormBase } from "../../util/form-base-form";

class BrandsFilterForm extends FormBase {
    public getPriorityFilterLabel(input: HTMLInputElement): HTMLLabelElement | null {
        return this.closest(input, "label", HTMLLabelElement);
    }

    public getFilterInputs(root: ParentNode): HTMLInputElement[] {
        return this.queryElements(
            root,
            'input.brand-filter-checkbox[name="country[]"], input.brand-filter-checkbox[name="brand_index[]"], input.brand-filter-radio[name="priority"]',
            HTMLInputElement,
        );
    }
}

const brandsFilterForm = new BrandsFilterForm();

export { BrandsFilterForm, brandsFilterForm };
